import React from "react";
import "./Team.css";
import TeamMember from "./TeamMember";

// 2026–27 roster, in the order of the team slide in our Preliminary Design Briefing
const teamMembers = [
  {
    name: "Eitan Zarin",
    role: "Power Systems, Biz Dev",
    image: "/images/team/eitan-zarin.jpg",
    link: "https://www.linkedin.com/in/eitanzarin/",
  },
  {
    name: "Samuel Indyk",
    role: "Mechanical, Software",
    image: "/images/team/samuel-indyk.jpg",
    link: "https://www.linkedin.com/in/samuel-indyk-b790b1272/",
  },
  {
    name: "Daniel Eastham",
    role: "Cutterhead",
    image: "/images/team/daniel-eastham.jpg",
    link: "https://www.linkedin.com/in/daniel-eastham-b30949264",
  },
  {
    name: "Moriah Adams",
    role: "Electrical, Software, Biz Dev",
    image: "/images/team/moriah-adams.jpg",
    link: "https://www.linkedin.com/in/moriah-adams",
  },
  {
    name: "Jack Nemtsov",
    role: "Muck Extraction",
    image: "/images/team/jack-nemtsov.jpg",
    link: "https://www.linkedin.com/in/jnemtsov",
  },
  {
    // TODO: LinkedIn link
    name: "Gavin Nelson",
    role: "Integration",
    image: "/images/team/gavin-nelson.jpg",
  },
  {
    // "Simrin" is correct; his LinkedIn URL just spells it "simran"
    name: "Simrin Dhaliwal",
    role: "Biz Dev",
    image: "/images/team/simrin-dhaliwal.jpg",
    link: "https://www.linkedin.com/in/simran-dhaliwal-",
  },
  {
    // TODO: LinkedIn link
    name: "Evangeline Boulineau",
    role: "Social Media, Admin",
    image: "/images/team/evangeline-boulineau.jpg",
  },
  {
    name: "Halyn Kim",
    role: "Lubrication",
    image: "/images/team/halyn-kim.jpg",
    link: "https://www.linkedin.com/in/halyn-kim-29ab90395/",
  },
  {
    name: "Edward Palacci",
    role: "Structures, Pipe Jacking",
    image: "/images/team/edward-palacci.jpg",
    link: "https://www.linkedin.com/in/edward-palacci/",
  },
];

// 2025–26 members who aren't on the 2026–27 roster
const alumni = [
  {
    name: "Judah Levin",
    role: "Mechanical, Manufacturing, Biz Dev",
    image: "/images/team/judah-levin.jpg",
    link: "https://www.linkedin.com/in/judah-levin/",
  },
  {
    name: "Max Weinstein",
    role: "Manufacturing",
    image: "/images/team/max-weinstein.jpg",
    link: "https://www.linkedin.com/in/maxjweinstein/",
  },
];

const facultyAdvisors = [
  {
    name: "Dave Ruth",
    role: "Provost, UATX",
    image: "/images/team/dave-ruth.jpg",
    link: "https://www.uaustin.org/people/david-ruth",
  },
  {
    name: "Clint Staley",
    role: "Dean of Sciences, UATX",
    image: "/images/team/clint-staley.jpg",
    link: "https://uaustin.org/people/clinton-staley/",
  },
  {
    // TODO: confirm Phil is still an advisor (our 2026–27 PDB lists only Dave and Clint)
    name: "Phil Greenwald",
    role: "Executive Director of Future Labs, UATX",
    image: "/images/team/phil-greenwald.jpg",
    link: "https://www.uaustin.org/people/phil-greenwald",
  },
];

const Team = () => {
  return (
    <section className="section">
      <h2 className="section-title">Team</h2>
      <div className="team-grid team-grid-five">
        {teamMembers.map((member) => (
          <TeamMember key={member.name} {...member} />
        ))}
      </div>

      <div className="faculty-section">
        <h3 className="faculty-title">Faculty Advisors</h3>
        <div className="team-grid">
          {facultyAdvisors.map((advisor) => (
            <TeamMember key={advisor.name} {...advisor} />
          ))}
        </div>
      </div>

      <div className="faculty-section">
        <h3 className="faculty-title">Alumni</h3>
        <div className="team-grid">
          {alumni.map((member) => (
            <TeamMember key={member.name} {...member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
